// SCR-008's routes (NAV-006 rate plans), composed into the route table by TASK-140.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { PlanEditor } from "./plan-editor";
import { PlanList } from "./plan-list";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-006", path: "/rate-plans", title: "Rate plans", permission: "billing:read", component: PlanList }),
  defineRoute({ nav: "NAV-006", path: "/rate-plans/new", title: "New rate plan", permission: "billing:write", component: PlanEditor }),
  defineRoute({ nav: "NAV-006", path: "/rate-plans/:planId", title: "Rate plan", permission: "billing:read", component: PlanEditor }),
];
